export default __webpack_public_path__ + "static/media/PCS-Button.7dd319e1.png";